"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.greaterThanInclusive = exports.greaterThan = exports.lessThanInclusive = exports.lessThan = exports.hasValueOperator = exports.doesNotMatchOperator = exports.matchesOperator = void 0;
const isString_1 = __importDefault(require("lodash/isString"));
const isDate_1 = __importDefault(require("lodash/isDate"));
const isArrayLike_1 = __importDefault(require("lodash/isArrayLike"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
function matchesOperator(factValue, regex) {
    return !factValue || regex.test(factValue);
}
exports.matchesOperator = matchesOperator;
function doesNotMatchOperator(factValue, regex) {
    return !factValue || !regex.test(factValue);
}
exports.doesNotMatchOperator = doesNotMatchOperator;
function hasValueOperator(factValue, checkedValue) {
    let result;
    if ((0, isString_1.default)(factValue)) {
        // Strings are truthy if they contain at least one character.
        result = !!factValue;
    }
    else if ((0, isDate_1.default)(factValue)) {
        // Date instance must represent a valid date.
        result = !isNaN(factValue.getTime());
    }
    else if ((0, isArrayLike_1.default)(factValue)) {
        result = factValue.length > 0;
    }
    else {
        // For everything else, just check that there is a value.  Note this
        // applies to boolean values as well (a boolean 'false' is still
        // considered to have a value).
        result = factValue !== undefined && factValue !== null;
    }
    return result === checkedValue;
}
exports.hasValueOperator = hasValueOperator;
function lessThan(factValue, value) {
    if ((0, isDate_1.default)(factValue) && (0, isDate_1.default)(value)) {
        return factValue.valueOf() < value.valueOf();
    }
    else if ((0, isString_1.default)(factValue) && (0, isString_1.default)(value)) {
        return factValue.valueOf() < value.valueOf();
    }
    else if ((0, isNumber_1.default)(factValue) && (0, isNumber_1.default)(value)) {
        return factValue < value;
    }
    return false;
}
exports.lessThan = lessThan;
function lessThanInclusive(factValue, value) {
    if ((0, isDate_1.default)(factValue) && (0, isDate_1.default)(value)) {
        return factValue.valueOf() <= value.valueOf();
    }
    else if ((0, isString_1.default)(factValue) && (0, isString_1.default)(value)) {
        return factValue.valueOf() <= value.valueOf();
    }
    else if ((0, isNumber_1.default)(factValue) && (0, isNumber_1.default)(value)) {
        return factValue <= value;
    }
    return false;
}
exports.lessThanInclusive = lessThanInclusive;
function greaterThan(factValue, value) {
    if ((0, isDate_1.default)(factValue) && (0, isDate_1.default)(value)) {
        return factValue.valueOf() > value.valueOf();
    }
    else if ((0, isString_1.default)(factValue) && (0, isString_1.default)(value)) {
        return factValue.valueOf() > value.valueOf();
    }
    else if ((0, isNumber_1.default)(factValue) && (0, isNumber_1.default)(value)) {
        return factValue > value;
    }
    return false;
}
exports.greaterThan = greaterThan;
function greaterThanInclusive(factValue, value) {
    if ((0, isDate_1.default)(factValue) && (0, isDate_1.default)(value)) {
        return factValue.valueOf() >= value.valueOf();
    }
    else if ((0, isString_1.default)(factValue) && (0, isString_1.default)(value)) {
        return factValue.valueOf() >= value.valueOf();
    }
    else if ((0, isNumber_1.default)(factValue) && (0, isNumber_1.default)(value)) {
        return factValue >= value;
    }
    return false;
}
exports.greaterThanInclusive = greaterThanInclusive;
//# sourceMappingURL=operators.js.map